import React, { useEffect } from "react";
import CheckoutModal from "./CheckoutModal";
import { useCart } from "../context/CartContext";
import { useCheckout } from "../context/CheckoutContext";

const CheckoutModalWrapper = () => {
  const { cartItems } = useCart();
  const { isOpen, type, closeCheckout } = useCheckout();

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <CheckoutModal
      isOpen={isOpen}
      onClose={closeCheckout}
      checkoutType={type}
      cartItems={cartItems}
    />
  );
};

export default CheckoutModalWrapper;
